import startOfDay from 'date-fns/startOfDay'
import { formatDateFromInputToApiQueryString } from './date'

export default {
  cpfCnpj: (number = '') => number.replace(/[./-]/g, ''),
  breakFullName: (name = '') =>
    name
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim()
      .match(/^(\w*)\s*(\w[\w\s]*\w)/)
      .slice(1),
  datePayloadPattern: (date) => startOfDay(new Date(`${date}T12:00:00Z`)),
  dateQueryPattern: (date) => formatDateFromInputToApiQueryString(date),
  cellphone: (number = "") => number.replace(/[()\s-]/g, ``),
}
